var m = Object.freeze, C = Object.defineProperty;
var s = (p, t) => m(C(p, "raw", { value: m(t || p.slice()) }));
import { L as k } from "./lds-form-element-SiTAij9m.js";
import { i as V, x as a } from "./lit-element-CwWchyls.js";
import { n } from "./property-EvzlnPW3.js";
import { r as h } from "./state-D88UmDIj.js";
import { e as E } from "./query-Dk6NwgU8.js";
import { e as v } from "./class-map-CiBNip0q.js";
import "./lds-dropdown.js";
import "./lds-icon.js";
import "./lds-tag.js";
import { o as q } from "./if-defined-BopGAQiw.js";
import { e as z, a as j } from "./context-D-64zexR.js";
var g;
const A = V(g || (g = s(["\n    :host {\n        display: inline-block;\n        width: 100%;\n        position: relative;\n    }\n\n    lds-dropdown {\n        width: 100%;\n    }\n\n    lds-dropdown::part(dropdown) {\n        position: fixed;\n        margin-right: 24px;\n        width: fit-content;\n    }\n\n    lds-tag {\n        margin-right: 6px;\n        max-width: 200px;\n        width: auto;\n    }\n\n    .placeholder {\n        opacity: 0.75;\n    }\n\n    label {\n        display: block;\n        font-weight: bold;\n    }\n\n    .trigger {\n        border-color: transparent;\n        border-width: var(--lds-input-border-width);\n        border-style: solid;\n        border-radius: var(--lds-input-border-radius);\n        height: var(--lds-input-height-md);\n        background: var(--lds-color-default-20);\n        color: var(--lds-text);\n        font-weight: normal;\n        display: flex;\n        align-items: center;\n        padding: 0 var(--lds-spacing-sm);\n        box-sizing: border-box;\n        position: relative;\n    }\n\n    .trigger.read-only {\n        opacity: 0.5;\n        cursor: text;\n    }\n\n    .options {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n    }\n\n    input {\n        position: absolute;\n        opacity: 0;\n        padding: 0;\n        margin: 0;\n        pointer-events: none;\n    }\n\n    .rotate-180 {\n        transform: rotateZ(180deg);\n    }\n\n    lds-icon {\n        margin-left: auto;\n    }\n\n    .has-error {\n        border-color: var(--lds-color-error);\n        border-width: var(--lds-input-border-width);\n        border-style: solid;\n    }\n\n    .error {\n        color: var(--lds-color-error);\n        font-size: var(--lds-font-size-xs);\n        line-height: var(--lds-font-size-sm);\n        padding-top: 4px;\n    }\n\n    .error-wrapper {\n        min-height: 18px;\n    }\n"])));
var L = Object.defineProperty, o = (p, t, e, l) => {
  for (var r = void 0, d = p.length - 1, u; d >= 0; d--)
    (u = p[d]) && (r = u(t, e, r) || r);
  return r && L(t, e, r), r;
}, f, b, y, x, O, w, $;
const c = class c extends k {
  constructor() {
    var t;
    super(...arguments), this.role = "listbox", this.required = !1, this.value = "", this.values = [], this.label = "", this.placeholder = "", this.selectedOptions = [], this.maxVisibleOptions = 3, this.context = {
      setActive: (e, l = !0) => {
        var r;
        this.toggleOption(e), this.values = (r = this.selectedOptions) == null ? void 0 : r.map((d) => d.value), this.value = this.values.join(", ") || "", this.updateContext(), l && this.emit("change");
      },
      activeOptions: ((t = this.selectedOptions) == null ? void 0 : t.map((e) => e.uuid)) || []
    }, this.readOnly = !1, this.open = !1;
  }
  toggleOption(t) {
    var l;
    const e = (l = this.selectedOptions) == null ? void 0 : l.findIndex((r) => r.uuid === t.uuid);
    e !== -1 ? this.selectedOptions.splice(e, 1) : this.selectedOptions.push(t);
  }
  firstUpdated() {
    this.setAttribute("aria-label", this.label), this.addEventListener("click", (t) => {
      t.composedPath()[0] === this && this.dropdownElement.onClick();
    });
  }
  updateContext() {
    var t;
    this.context = { ...this.context, activeOptions: ((t = this.selectedOptions) == null ? void 0 : t.map((e) => e.uuid)) || [] };
  }
  removeOption(t, e) {
    e.detail.originalEvent.stopImmediatePropagation(), this.context.setActive(t);
  }
  get validationElement() {
    return this.input;
  }
  willUpdate(t) {
    t.has("values") && (this.value = this.values.join(", ")), t.has("value") && (this.values = this.value.split(", ")), this.selectedOptions = [], this.values.forEach((e) => {
      const l = this.querySelector('[value="'.concat(e, '"]'));
      l && this.selectedOptions.push(l);
    }), setTimeout(() => {
      this.updateContext();
    });
  }
  get slicedOptions() {
    return this.selectedOptions.slice(0, this.maxVisibleOptions);
  }
  onDropdownChange(t) {
    if (this.readOnly) {
      t.target.open = !1;
      return;
    }
  }
  render() {
    return a($ || ($ = s(["\n            ", '\n            <input\n                type="text"\n                ?required=', '\n                tabindex="-1"\n                .value=', '\n                id="input"\n                aria-hidden="true" />\n            <lds-dropdown @change=', ' stay-open-on-click part="dropdown">\n                <div\n                    class="trigger ', '"\n                    slot="trigger"\n                    part="trigger">\n                    <slot name="selected" part="selected">\n                        ', '\n                    </slot>\n                    <lds-icon\n                        part="icon"\n                        name="chevron-down"\n                        class="', '"></lds-icon>\n                </div>\n                <div class="options" part="options">\n                    <slot></slot>\n                </div>\n            </lds-dropdown>\n            <div class="error-wrapper" part="error-wrapper">\n                ', "\n                ", "\n            </div>\n        "])), q(this.label) ? a(f || (f = s(['<label part="label">', "</label>"])), this.label) : "", this.required, this.value, this.onDropdownChange, v({ "has-error": this.hasError, "read-only": this.readOnly }), this.selectedOptions.length ? [
      this.slicedOptions.map(
        (t) => a(b || (b = s(["<lds-tag\n                                              removable\n                                              @remove=", "\n                                              >", "</lds-tag\n                                          >"])), (e) => this.removeOption(t, e), t.getTextLabel())
      ),
      this.selectedOptions.length > this.maxVisibleOptions ? a(y || (y = s(['<lds-tag class="more"\n                                            >+', "</lds-tag\n                                        >"])), this.selectedOptions.length - this.maxVisibleOptions) : ""
    ] : a(x || (x = s(['<span class="placeholder">', "</span>"])), this.placeholder), v({
      "rotate-180": this.open
    }), this.currentValidationErrors.map((t) => a(O || (O = s(['<div class="error">', "</div>"])), t)), this.errors.map((t) => a(w || (w = s(['<div class="error">', "</div>"])), t)));
  }
};
c.styles = A;
let i = c;
o([
  n({ type: String, reflect: !0 })
], i.prototype, "role");
o([
  n({ type: Boolean, reflect: !0 })
], i.prototype, "required");
o([
  n({ type: String, reflect: !0 })
], i.prototype, "value");
o([
  h()
], i.prototype, "values");
o([
  n({ type: String })
], i.prototype, "label");
o([
  n({ type: String })
], i.prototype, "placeholder");
o([
  h()
], i.prototype, "selectedOptions");
o([
  n({ type: Number })
], i.prototype, "maxVisibleOptions");
o([
  z({ context: j }),
  h()
], i.prototype, "context");
o([
  E("input")
], i.prototype, "input");
o([
  n({ type: Boolean, attribute: "read-only" })
], i.prototype, "readOnly");
o([
  h()
], i.prototype, "open");
o([
  E("lds-dropdown")
], i.prototype, "dropdownElement");
export {
  i as L
};
